import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";

const features = [
  { icon: "ri-currency-line", title: "实时更新", desc: "榜单热度实时刷新，不错过任何一部新作。" },
  { icon: "ri-star-smile-line", title: "编辑甄选", desc: "专业编辑从口碑与品质出发，去芜存菁。" },
  { icon: "ri-checkbox-circle-line", title: "必看清单", desc: "帮你快速锁定当下最值得追的高分作品。" },
  { icon: "ri-group-line", title: "人气社区", desc: "数万读者共同推荐，热度数据真实可信。" },
];

export default function Intro() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow="关于漫天堂"
            title="让每一部好作品，都能被看见"
            description="漫天堂是一个专注于漫画人气与热度排行的内容平台。我们相信好作品不该被埋没，于是用实时数据与专业编辑的双重把关，帮你从海量内容中挑出真正值得追的漫画。"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((f) => (
              <div
                key={f.title}
                className="flex gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                  <i className={f.icon}></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">{f.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6">
            <Link
              to="/about"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              了解我们更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Cozy%20reading%20corner%20with%20stacks%20of%20comic%20books%20and%20a%20warm%20lamp%2C%20soft%20afternoon%20sunlight%20streaming%20through%20a%20window%2C%20cream%20and%20amber%20palette%2C%20editorial%20photography%20for%20a%20comic%20community%20website&width=1200&height=900&seq=about-preview&orientation=landscape"
            alt="漫天堂漫画阅读社区"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}